<template>
  <div class="section-category section-full">
    <grid-view :type="'staff'" :items="staffs" @pickItem="pickStaff"></grid-view>
  </div>
</template>

<script>
import GridView from '@/components/GridView.vue';
import { SET_CONFIRM_MODAL, SET_MESSAGE_MODAL } from "@/store/mutation-types";
import { SET_STAFF_STATION } from '@/store/action-types';
import { mapGetters } from 'vuex';

export default {
  name: 'staffs',
  components: {
    GridView,
  },
  computed: {
    staffPage() { return this.getMap('staffPage', true) },
    staffs() {
      const s = this.staffMap;
      return this.getArray('staffs').filter(staff => {
        return  (this.isRole(staff.subRoles, 'Order taker / Staff / Waitress') || this.isRole(staff.subRoles, 'Other Staff')) 
                && (this.staffPage == null 
                    || (staff.location == this.user.location.id) == this.staffPage); 
      }).sort((a, b) => a.ref - b.ref);
    },
    staffMap() {
      return this.$store.state.staff.staffs;
    },
    user() {
      return this.$store.state.auth.user;
    },
    station() { return this.getMap('user', true).station },
    ...mapGetters([
      'checkStaffLocation', 
    ]),
  },
  methods: {
    isRole(items, key) {
      let flag = false;
      items.forEach(item => {
        let role = this.getObject(item, "roles");
        if (role && role.name == key) flag = true;
      });
      return flag;
    },
    async pickStaff(staff) {
      if(!this.isCashier) {
        this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Permission denied'));
        return;
      }
      const _this = this;
      const data = {
        staffId: staff.id,
        setStationNull: !this.checkStaffLocation(staff) ? true : false,
        station: this.checkStaffLocation(staff) ? null : this.station.id,
      }
      const modalHeaderText = ((staff.location && staff.location == this.user.location.id)
                                ? this.$gettext('sign out staff') 
                                : this.$gettext('sign in staff')
                              ) + ' ' + staff.firstName + ' ' + staff.lastName;
      this.$store.commit(SET_CONFIRM_MODAL, {
        action: modalHeaderText,
        context: this,
        data: data,
        func: () => _this.$store.dispatch(SET_STAFF_STATION, data),
      });
    }
  },
  mounted() {
    const { path } = this.$router.currentRoute;
    if (path.includes('in')) {
      this.$store.state.staff.staffPage = true;
    } else if (path.includes('out')) {
      this.$store.state.staff.staffPage = false;
    }
  },
};

</script>
